// data/advisoryBoardData.js

export const advisoryBoardMembers = [
  {
    id: "ab-1",
    name: "Dr. Sandeep Marwah",
    designation:
      "Founder, Marwah Studios | Chancellor, AAFT University of Media and Arts ",
    image: "/img/sandeep marwah (1).jpg",
  },
  {
    id: "ab-2",
    name: "Prof. Christopher Abraham",
    designation: "CEO & Head, Dubai Campus, S.P. Jain School of Global Management",
    image: "/img/Prof.-Christopher-Abraham-1 (1).jpg",
  },
  {
    id: "ab-3",
    name: "Vivek Nagpaul",
    designation: "Owner, Euroasian | Utrecht Area, Netherlands",
    image: "/img/Vivek (1).jpg",
  },
  {
    id: "ab-4",
    name: "Saâdia Lakehal",
    designation:
      "CEO, Emperia Industries Connect | Pioneering Leader in Industry 4.0 & AgTech",
    image: "/img/saadia (1).jpg",
  },
  {
    id: "ab-5",
    name: "Probir Roy",
    designation: "Serial Entrepreneur | Co-founder, Paymate",
    image: "/img/Probir-Roy (2).jpg",
  },
  {
    id: "ab-6",
    name: "Sapna Dudaanii",
    designation: "Founder, Synchronic Alliance",
    image: "/img/Sapna (1).jpg",
  },
  {
    id: "ab-7",
    name: "Sushil Agarwal",
    designation: "Chairman, AVON Moldplast Limited",
    image: "/img/sushil (1).jpg",
  },
  {
    id: "ab-8",
    name: "Naveen Sharma",
    designation: "Chairman, Athena Ventures",
    image: "/img/naveen (1).jpg",
  },
  {
    id: "ab-9",
    name: "Rajesh B Lund",
    designation: "President, ICCIC",
    image: "/img/rajesh (1).jpg",
  },
  {
    id: "ab-10",
    name: "Anshu Aanand",
    designation: "Business Advisor",
    image: "/img/aanshu.jpg",
  },
  {
    id: "ab-11",
    name: "Er Ramesh Kumar",
    designation: "Chairman, Beltron Telecom Green Energy Systems Limited",
    image: "/img/ramesh (1).jpg",
  },
  {
    id: "ab-12",
    name: "Zeeshaan Pathan",
    designation: "Group MD & CEO, World Development Corporation",
    image: "/img/zeeshan (1).jpg",
  },
  {
    id: "ab-13",
    name: "Prof (Dr.) Ajay Kumar Jain",
    designation: "MDI, Gurugram",
    image: "/img/Ajay-Kumar-Jain (1).jpg",
  },
  {
    id: "ab-14",
    name: "Ayub Sheikh",
    designation: "MD | Fintech & AI Expert, World Development Corporation",
    image: "/img/ayub (1).jpg",
  },
  {
    id: "ab-15",
    name: "Sarita Chauhan",
    designation: "Director, Farsighters Network",
    image: "/img/sarita (1).jpg",
  },
  {
    id: "ab-16",
    name: "Shubham Sharma",
    designation: "CEO, Heylin Spark, Rajasthan",
    image: "/img/shubham (1).jpg",
  },
  {
    id: "ab-17",
    name: "Dr. Binod Kumar",
    designation: "Chairman, Abhigyan Consultants",
    image: "/img/binod (1).jpg",
  },
  {
    id: "ab-18",
    name: "Shailendra Kumar",
    designation: "Founder Editor, Taxindiaonline.com",
    image: "/img/Shailendra-Kumar (1).jpg",
  },
  {
    id: "ab-19",
    name: "Heval Mehta",
    designation:
      "MD, Directors' Institute ",
    image: "/img/heval (1).jpg",
  },
  {
    id: "ab-20",
    name: "M.N. Pamanabhan",
    designation: "Managing Director, Lakshaka Tex LLP",
    image: "/img/Padmnabham.jpg",
  },
];